import React, { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import _ from 'lodash';
import {
  updateDepartmentSetting,
  updateVehicleColumn,
  updateVehicleColumnOption,
} from '../actions/apiDepartmentUpdates';
import {
  updateVehicleDepartment,
} from '../actions/AllUpdates';
import {
  sendEstimate,
  sendEstimateRaw,
} from '../actions/apiEstimates';
import {
  setSingleUser,
  editWorkFlows,
  setCurrentReport,
  setReportStartDate,
  setReportEndDate,
  setReportTimeRange,
  setEditDepartments,
  setVehicleTab,
  setMonthlyReportDepartments,
  setMonthlyReportWorkFlows,
} from '../actions/apiSetInfo';
import {
  addDealerSetting,
} from '../actions/apiDealerUpdates';
import {
  updateFilter,
} from '../actions/apiFilters';
import {
  editUserProfile,
} from '../actions/users';
import {
  activeEditDepartment,
  activeVehicle,
} from '../actions/lookups';

const Dropdown = (props) => {
  const dispatch = useDispatch();
  const installation = useSelector((state) => state.settings_dealerships.installation);

  const [listOpen, setListOpen] = useState(false);
  const [headerTitle, setHeaderTitle] = useState(props.value || props.title || 'Choose');
  const [list, setList] = useState(props.list || []);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const updateHeaderTitleAndList = () => {
      const { value, list: propList, update_type } = props;
      if (!value || !propList || propList.length === 0) {
        setHeaderTitle(value || props.title || 'Choose');
        setList(propList || []);
        return;
      }

      let index = -1;
      let selectedItem = null;

      if (update_type === 'subdomain') {
        index = _.findIndex(propList, { subdomain: value });
      } else if (update_type === 'report_time_range') {
        index = _.findIndex(propList, { name: value });
      } else if (update_type.includes('dealership_setting')) {
        index = _.findIndex(propList, { name: value });
      } else if (isNaN(value)) {
        index = _.findIndex(propList, { label: value });
      } else {
        index = _.findIndex(propList, { id: parseInt(value) });
      }

      if (index === -1) {
        index = _.findIndex(propList, { selected: true });
      }

      if (index !== -1) {
        selectedItem = propList[index];
        const updatedList = propList.map((item, ind) => ({
          ...item,
          selected: ind === index,
        }));
        setList(updatedList);
        setHeaderTitle(selectedItem.label);
         // console.log({ name: props.name, value, selectedLabel: selectedItem.label, update_type, source: 'updateHeaderTitleAndList' });
      } else {
        setHeaderTitle(value || props.title || 'Choose');
        setList(propList || []);
      }
    };

    updateHeaderTitleAndList();
  }, [props.value, props.list, props.update_type, props.title, props.name]);

  useEffect(() => {
    const closeListener = (e) => {
      if (listOpen && dropdownRef.current && !dropdownRef.current.contains(e.target)) {
         // console.log({ name: props.name, action: 'closeListener', listOpen });
        setListOpen(false);
      }
    };
    window.addEventListener('click', closeListener);
    return () => window.removeEventListener('click', closeListener);
  }, [listOpen, props.name]);

  const toggleList = () => {
     // console.log({ name: props.name, action: 'toggleList', listOpen });
    setListOpen((prev) => !prev);
  };

  const selectItem = (title, id) => {
     // console.log({ name: props.name, action: 'selectItem', title, id });
    setHeaderTitle(title);
    setListOpen(false);
    resetThenSet(id);
  };

  const resetThenSet = (id) => {
    const index = _.findIndex(list, { id: parseInt(id) });
    if (index === -1) return;

    const updatedList = list.map((item, ind) => ({
      ...item,
      selected: ind === index,
    }));

    const selectedItem = updatedList[index];
    const newHeaderTitle = selectedItem.label;

    if (props.update_type === 'subdomain_department') {
      const data = { id: props.department_id, subdomain_department: selectedItem.id };
      dispatch(updateDepartmentSetting(props.department_id, data, 'editVehicleColumnError'));
    } else if (props.update_type === 'vehicle_column') {
      const data = { id: props.vehicle_column_id, [props.name]: selectedItem.value };
      dispatch(updateVehicleColumn(data.id, data, 'editVehicleColumnError'));
    } else if (props.update_type === 'option') {
      const data = { id: props.option_id, [props.name]: selectedItem.value };
      dispatch(updateVehicleColumnOption(data.id, props.column_id, data, 'editOptionError'));
    } else if (props.update_type === 'all_filter') {
      const data = { id: props.all_filter_id, [props.name]: selectedItem.value };
      dispatch(updateFilter(data.id, data, 'editAllFilter'));
    } else if (props.update_type === 'select_department') {
      dispatch(updateVehicleDepartment(props.vehicle_id, 'department_id', selectedItem.id, props.vehicle));
    } else if (props.update_type === 'vehicle_body') {
      props.onChange(selectedItem.label);
    } else if (props.update_type === 'uvi_form_vehicle') {
      props.onChange(
        selectedItem.label,
        selectedItem.part_number,
        selectedItem.qty,
        selectedItem.parts,
        selectedItem.labor_hours,
        selectedItem.labor,
        selectedItem.total,
        selectedItem.work_id
      );
    } else if (props.update_type === 'vehicleproperty') {
      props.onChange(selectedItem.label, props.name);
    } else if (props.update_type === 'subgroup') {
      const data = { id: props.department_id, subgroup: selectedItem.id };
      dispatch(updateDepartmentSetting(props.department_id, data, 'subgroup'));
    } else if (props.update_type === 'single_user') {
      dispatch(setSingleUser(selectedItem.id));
    } else if (props.update_type === 'edit_work_flows') {
      if (props.onChange) {
        props.onChange(selectedItem);
      }
      dispatch(editWorkFlows(selectedItem.id));
    } else if (props.update_type === 'department_type') {
      const data = { id: props.department_id, department_type: selectedItem.label };
      dispatch(updateDepartmentSetting(props.department_id, data, 'department_type'));
    } else if (props.update_type === 'dealership_setting') {
      const data = { key: props.name, value: selectedItem.label, dealership: installation.subdomain };
      dispatch(addDealerSetting(data, 'dealership_setting'));
    } else if (props.update_type === 'pay_type') {
      const data = { id: selectedItem.estimate_id, type_item_2: selectedItem.name };
      dispatch(sendEstimate(selectedItem.estimate_id, data, 'sendEstimate'));
    } else if (props.update_type === 'new_work_item') {
      const data = {
        id: props.estimate_id,
        item_1: selectedItem.item_1,
        item_2: selectedItem.item_2,
        item_3: selectedItem.item_3,
        type_item_5: selectedItem.type_item_5,
        classification: selectedItem.classification,
        estimate: selectedItem.estimate,
        vehicle_id: props.vehicle_id,
        description: selectedItem.value,
      };
      dispatch(sendEstimate(props.estimate_id, data, 'sendEstimate'));
    } else if (props.update_type === 'dealership_setting_department') {
      const data = { key: props.name, value: selectedItem.id, dealership: installation.subdomain };
      dispatch(addDealerSetting(data, 'dealership_setting'));
    } else if (props.update_type === 'dealership_setting_report_hours') {
      const data = { key: props.name, value: selectedItem.name, dealership: installation.subdomain };
      dispatch(addDealerSetting(data, 'dealership_setting'));
    } else if (props.update_type === 'dealership_setting_time_tabs') {
      const data = { key: props.name, value: selectedItem.name, dealership: installation.subdomain };
      dispatch(addDealerSetting(data, 'dealership_setting'));
    } else if (props.update_type === 'dealership_setting_workflows') {
      const data = { key: props.name, value: selectedItem.label, dealership: installation.subdomain };
      dispatch(addDealerSetting(data, 'dealership_setting'));
    } else if (props.update_type === 'subdomain') {
      const data = { id: props.department_id, subdomain: selectedItem.subdomain };
      dispatch(updateDepartmentSetting(props.department_id, data, 'subdomain'));
    } else if (props.update_type === 'vehicle_subdomain') {
      const data = { id: props.vehicle_id, subdomain: selectedItem.name };
      dispatch(updateVehicleData(props.department_id, data));
    } else if (props.update_type === 'vehicle_dealership') {
      const data = { id: props.vehicle_id, dealership: selectedItem.name };
      dispatch(updateVehicleData(props.department_id, data));
    } else if (props.update_type === 'set_current_report') {
      dispatch(setCurrentReport(selectedItem.label));
    } else if (props.update_type === 'set_edit_department') {
      dispatch(activeEditDepartment(selectedItem.id));
      dispatch(setEditDepartments(selectedItem.id));
    } else if (props.update_type === 'set_monthly_report_departments') {
      dispatch(setMonthlyReportDepartments(selectedItem.id));
    } else if (props.update_type === 'set_monthly_report_work_flows') {
      dispatch(setMonthlyReportWorkFlows(selectedItem.id));
    } else if (props.update_type === 'report_time_range') {
      dispatch(setReportTimeRange(selectedItem.name));
      const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
      if (months.includes(selectedItem.label)) {
        let date = new Date();
        let datefirst = new Date();
        let lastdigit = new Date();
        if (selectedItem.name === 'last') {
          datefirst.setMonth(date.getMonth() - 1);
          datefirst.setDate(1);
          lastdigit = new Date(date.getFullYear(), date.getMonth(), 0);
        } else if (selectedItem.name === 'second') {
          datefirst.setMonth(date.getMonth() - 2);
          datefirst.setDate(1);
          lastdigit = new Date(date.getFullYear(), date.getMonth() - 1, 0);
        } else if (selectedItem.name === 'third') {
          datefirst.setMonth(date.getMonth() - 3);
          datefirst.setDate(1);
          lastdigit = new Date(date.getFullYear(), date.getMonth() - 2, 0);
        }
        const start = `${datefirst.getFullYear()}-${(`0${datefirst.getMonth() + 1}`).slice(-2)}-${(`0${datefirst.getDate()}`).slice(-2)}`;
        const end = `${datefirst.getFullYear()}-${(`0${datefirst.getMonth() + 1}`).slice(-2)}-${lastdigit.getDate()}`;
        dispatch(setReportStartDate(start));
        dispatch(setReportEndDate(end));
      } else if (selectedItem.label.includes('days')) {
        const date = new Date();
        const startdate = new Date();
        startdate.setDate(startdate.getDate() - Number(selectedItem.name));
        const start = `${startdate.getFullYear()}-${(`0${startdate.getMonth() + 1}`).slice(-2)}-${(`0${startdate.getDate()}`).slice(-2)}`;
        const end = `${date.getFullYear()}-${(`0${date.getMonth() + 1}`).slice(-2)}-${(`0${date.getDate()}`).slice(-2)}`;
        dispatch(setReportStartDate(start));
        dispatch(setReportEndDate(end));
      } else if (selectedItem.label === 'Month to Date') {
        const date = new Date();
        const startdate = new Date();
        startdate.setDate(1);
        const start = `${startdate.getFullYear()}-${(`0${startdate.getMonth() + 1}`).slice(-2)}-${(`0${startdate.getDate()}`).slice(-2)}`;
        const end = `${date.getFullYear()}-${(`0${date.getMonth() + 1}`).slice(-2)}-${(`0${date.getDate()}`).slice(-2)}`;
        dispatch(setReportStartDate(start));
        dispatch(setReportEndDate(end));
      }
    } else if (props.update_type === 'position') {
      const data = { position: selectedItem.label };
      dispatch(editUserProfile(props.user_id, data, 'editUserProfile'));
    } else if (props.update_type === 'notification_preference') {
      const data = { notification_preference: selectedItem.label };
      dispatch(editUserProfile(props.user_id, data, 'editUserProfile'));
    }

    setList(updatedList);
    setHeaderTitle(newHeaderTitle);
  };

  return (
    <div className="dd-wrapper" ref={dropdownRef} key={`select_me${props.vehicle_id}`} tabIndex={props.tabindex}>
      <div className="dd-header" onClick={() => {
         // console.log({ name: props.name, action: 'headerClick', listOpen });
        toggleList();
      }}>
        <div className="dd-header-title">{headerTitle}</div>
        <div className="text-muted">
          {listOpen
            ? <i className="fal fa-2x fa-angle-up text-muted" />
            : <i className="fal fa-2x fa-angle-down text-muted" />}
        </div>
      </div>
      {!props.disabled && listOpen && (
        <ul className={list.length > 10 ? 'dd-list scroll' : 'dd-list'} onClick={(e) => {
           // console.log({ name: props.name, action: 'listClick', event: 'stopPropagation' });
          e.stopPropagation();
        }}>
          {list.map((item) => (
            <li
              className={item.selected ? 'dd-list-item selected' : 'dd-list-item'}
              key={item.id}
              onClick={() => selectItem(item.label, item.id)}
            >
              {item.label}
              {item.selected && <i className="fas fa-check float-right" />}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default Dropdown;